import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('buttonlink');

export { TAG_NAME };